import { ICompileService } from "angular";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../records/forms/formly/fieldConfigurationHelpers";
import {
  FormSubmitArgs,
  FormViewConfig,
  FormViewService,
  FormViewServiceProvider,
  vsProviderName as FormViewServiceProviderName,
  vsServiceName as FormViewServiceName,
} from "../../../records/forms/formView";
import { RecordDataSource } from "../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import { FilterProvider } from "../../../records/grids/columns/filters/FilterProvider";
import { LookupFilter } from "../../../records/grids/columns/filters/subFilters/LookupFilter";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import fieldHelpers from "../../../ui-formly/fieldHelpers";
import {
  LookupManagementServiceProvider,
  vsProviderName as LookupManagementServiceProviderName,
} from "../components/lookupManagement";
import { MachineArea } from "../models/machineConfiguration";

export const vsObjectName = "machineArea";

MachineAreaConfig.$inject = [
  FormViewServiceProviderName,
  RecordGridViewServiceProviderName,
  LookupManagementServiceProviderName,
];
export function MachineAreaConfig(
  formViewServiceProvider: FormViewServiceProvider,
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  lookupManagementServiceProvider: LookupManagementServiceProvider
) {
  formViewServiceProvider.addFormViewConfig(vsObjectName, getFormConfig);
  recordGridViewServiceProvider.addGridConfiguration(
    vsObjectName,
    getGridConfig
  );
  lookupManagementServiceProvider.addLookup(vsObjectName, {
    displayName: "Area",
    config: [
      ServerUtilityName,
      (serverUtility: ServerUtility) => {
        return {
          fetchFormModel: (id) =>
            serverUtility.querySingle({
              url: "/api/machines/MachineArea",
              query: { Id: id },
            }),
        };
      },
    ],
  });
}

getFormConfig.$inject = [
  FieldConfigurationHelperServiceName,
  FormViewServiceName,
];
function getFormConfig(
  fieldConfigurationHelperService: FieldConfigurationHelperService,
  formViewService: FormViewService
): FormViewConfig {
  return {
    fields: [
      fieldConfigurationHelperService.selectAsyncField({
        key: "PropertyId",
        name: "PropertyId",
        label: "Property",
        required: true,
        getDefaultItem: (model) => {
          return { Id: model.PropertyId, Name: model.PropertyName };
        },
        queryUrl: "/api/properties",
      }),
      fieldHelpers.simpleStringField({
        key: "Name",
        label: "Area",
        required: true,
      }),
    ],
    title: (model) => (model.Id ? "Edit Area" : "Create Area"),
    name: vsObjectName,
    submitForm: (args: FormSubmitArgs) => {
      const model = <MachineArea>args.model;
      return formViewService.saveForm({
        formObject: model,
        formViewController: args.formViewController,
        url: "/api/machines/MachineArea",
      });
    },
  };
}

getGridConfig.$inject = [
  ColumnDefinitionServiceName,
  "$compile",
  ServerUtilityName,
];
function getGridConfig(
  columnDefinitionService: ColumnDefinitionService,
  $compile: ICompileService,
  serverUtility: ServerUtility
): GridConfiguration {
  return {
    columns: [
      columnDefinitionService.getStringColDef({
        field: "PropertyName",
        header: "Property",
        filter: new FilterProvider("PropertyName", $compile)
          .defaultStringFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["PropertyId"],
              serverQuery: (search) =>
                serverUtility.lookupQuery({
                  url: "/api/properties",
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "Name",
        header: "Area",
        filter: new FilterProvider("Name", $compile)
          .defaultStringFilters()
          .getGridFilterFactory(),
      }),
    ],
    gridDataSource: new RecordDataSource(
      serverUtility,
      "/api/machines/MachineArea"
    ),
    defaultSort: "PropertyName,Name",
    namePlural: "Areas",
    nameSingular: "Area",
    showAddButton: true,
    showAddButtonPermission: "machineEdit",
    showSelectButtons: false,
  };
}
